import { Route } from '../../store';
import { HoldingsContainer } from './container';

export const holdingsRoutes: Route[] = [
  {
    path: '/holdings',
    component: HoldingsContainer,
  },
];
